export enum GroupStatusEnum {
	NO_SCHEDULE = "NO_SCHEDULE",
	SCHEDULE_CREATED = "SCHEDULE_CREATED"
}
